import config from 'app/config';
import request from 'superagent';
import createAuthUrl from 'shared/helpers/create-auth-url';

export default email =>
  new Promise((resolve, reject) => {
    const authHost = config.get('AUTH_HOST');
    const endpoint = `${authHost}/v1/sendPasswordReset`;
    const recoverUrl = createAuthUrl('recover');

    request
      .post(endpoint)
      .send({ email, recoverUrl })
      .end((err, res) => {
        if (err) {
          return reject(err);
        }
        return resolve(res.body);
      });
  });
